export default class Intervento{
    CodiceIntervento;
    Stato;
    CodiceStato
    Tipo;
    Data;
    Company;
    Cliente;
    DataDaEffettuarsiEntro;
    DataAssegnazione;
    DataPresaInCarico;
    DataEffettuazione;
    DescrizioneUnita
    FirmaAssegnazione;
    ReferenteAzienda
    DataNonOltre;
    NoteAssegnazione;
    SysChiaveglobale;
    CodiceSito;
    NoteAssegnazione;
    NotePresaInCarico;
    DescrizioneSito;
    DataPresaInCarico;
    SysChiaveglobale;
    FirmaPresaInCarico;
}